import { type Channel, ProductType } from "@/api_client";
import { BabyEntryForm } from "@/components/products/baby/entry/BabyEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import type { Locales } from "@/graphql/generated";
import { useEntryContentExternal } from "@/services/cms/tanstackQuery/hooks/useEntryContentExternal";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type BabyEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function BabyEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<BabyEntryProps>) {
  const { isLoading, isSubmitting, submitEntryHandler, policyHolder, user } =
    useEntryForWebComponents({
      productType: "baby",
      backendHost,
      appPathPrefix,
      skipCart,
      channel,
      language,
    });

  const { data: content, isLoading: isLoadingContent } =
    useEntryContentExternal({
      product: ProductType.BABY,
      language: language as Locales,
      appPathPrefix,
    });

  if (isLoading || isLoadingContent) return <ProductContainer.Loader />;

  return (
    <BabyEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
